import { createSelector } from 'reselect'

import { selectAccountPreferenceCrmSidebar } from 'selectors/app/selectAccountPreferences'

export { default as selectCurrentSearchTerm } from './selectCurrentSearchTerm'

export const selectNewSideBarEnabled = createSelector(
  selectAccountPreferenceCrmSidebar,
  preference => {
    return preference
  }
)
